<template>
  <div>
    <!-- Bottom sheet para encerrar a O.S. -->
    <v-bottom-sheet v-if="tipo === 'encerrar'" v-model="localAberto">
      <v-card class="rounded-t-xl">
        <div class="d-flex justify-center pt-3 pb-1">
          <div style="width: 40px; height: 4px; background-color: #e0e0e0; border-radius: 2px;"></div>
        </div>

        <v-card-title class="headline d-flex justify-space-between align-center px-6 pt-2 pb-4">
          <div class="d-flex align-center">
            <v-icon color="#4c6faf" class="mr-2">mdi-check-circle-outline</v-icon>
            <span class="font-weight-bold" style="color: #4c6faf; font-size: 1.25rem;">Encerrar Ordem de Serviço</span>
          </div>
          <v-btn icon color="grey darken-1" small @click="$_cancelar" aria-label="Fechar">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="px-6 pb-4">
          <p class="subtitle-1 text--primary mb-3">Deseja realmente encerrar esta Ordem de Serviço?</p>
          
          <div v-if="localDados" class="rounded grey lighten-4 pa-4">
            <div class="d-flex justify-space-between mb-2">
              <span class="text-body-2 grey--text text--darken-2 font-weight-medium">Cliente:</span>
              <span class="text-body-2 font-weight-bold black--text text-right">
                {{ localDados.prsidcliente }} - {{ localDados.prsnomecliente || 'CONSUMIDOR DIVERSOS' }}
              </span>
            </div>
            
            <div class="d-flex justify-space-between mb-2" v-if="localDados.numeroExibicao">
              <span class="text-body-2 grey--text text--darken-2 font-weight-medium">Nº O.S.:</span>
              <span class="text-body-2 font-weight-bold black--text text-right">{{ localDados.numeroExibicao }}</span>
            </div>
            
            <div class="d-flex justify-space-between" v-if="localDados.total !== undefined && localDados.total !== null">
              <span class="text-body-2 grey--text text--darken-2 font-weight-medium">Total:</span>
              <span class="text-body-2 font-weight-bold black--text">{{ formatarValor(localDados.total) }}</span>
            </div>

            <template v-if="localDados.defeito">
              <v-divider class="my-3"></v-divider>
              <div>
                <span class="text-caption grey--text text--darken-2 font-weight-bold d-flex align-center mb-1">
                  Defeito:
                </span>
                <p class="text-body-2 black--text mb-0" style="white-space: pre-line;">{{ localDados.defeito }}</p>
              </div>
            </template>

            <template v-if="localDados.observacao">
              <v-divider class="my-3"></v-divider>
              <div>
                <span class="text-caption grey--text text--darken-2 font-weight-bold d-flex align-center mb-1">
                  Observação:
                </span>
                <p class="text-body-2 black--text mb-0" style="white-space: pre-line;">{{ localDados.observacao }}</p>
              </div>
            </template>
          </div>
        </v-card-text>

        <v-card-actions class="px-6 pb-6 pt-0 justify-end">
          <v-btn text color="grey darken-1" class="mr-3 text-capitalize font-weight-medium" @click="$_cancelar">
            Cancelar
          </v-btn>
          <v-btn color="#4c6faf" dark elevation="0" class="px-5 text-capitalize font-weight-medium" @click="$_confirmar">
            <v-icon left size="20">mdi-check</v-icon>
            Encerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-bottom-sheet>

    <!-- Bottom sheet para confirmação de exclusão (deletar) da O.S. -->
    <v-bottom-sheet v-if="tipo === 'delete'" v-model="localAberto">
      <v-card class="rounded-t-xl">
        <div class="d-flex justify-center pt-3 pb-1">
          <div style="width: 40px; height: 4px; background-color: #e0e0e0; border-radius: 2px;"></div>
        </div>

        <v-card-title class="headline d-flex justify-space-between align-center px-6 pt-2 pb-4">
          <div class="d-flex align-center">
            <v-icon color="error" class="mr-2">mdi-alert-circle-outline</v-icon>
            <span class="font-weight-bold error--text" style="font-size: 1.25rem;">Confirmar Exclusão</span>
          </div>
          <v-btn icon color="grey darken-1" small @click="$_cancelar" aria-label="Fechar">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="px-6 pb-4">
          <p class="subtitle-1 text--primary mb-3">Tem certeza que deseja excluir este pedido? Esta ação não poderá ser desfeita.</p>
          
          <div v-if="localDados" class="rounded grey lighten-4 pa-4 mb-4">
            <div class="d-flex justify-space-between mb-2">
              <span class="text-body-2 grey--text text--darken-2 font-weight-medium">Cliente:</span>
              <span class="text-body-2 font-weight-bold black--text text-right">
                {{ localDados.prsidcliente }} - {{ localDados.prsnomecliente || 'CONSUMIDOR DIVERSOS' }}
              </span>
            </div>
            <div class="d-flex justify-space-between mb-2" v-if="localDados.numeroExibicao">
              <span class="text-body-2 grey--text text--darken-2 font-weight-medium">Nº O.S.:</span>
              <span class="text-body-2 font-weight-bold black--text">{{ localDados.numeroExibicao }}</span>
            </div>
            <div class="d-flex justify-space-between" v-if="localDados.total !== undefined && localDados.total !== null">
              <span class="text-body-2 grey--text text--darken-2 font-weight-medium">Total:</span>
              <span class="text-body-2 font-weight-bold black--text">{{ formatarValor(localDados.total) }}</span>
            </div>
          </div>
        </v-card-text>

        <v-card-actions class="px-6 pb-6 pt-0 justify-end">
          <v-btn text color="grey darken-1" class="mr-3 text-capitalize font-weight-medium" @click="$_cancelar">
            Cancelar
          </v-btn>
          <v-btn color="error" dark elevation="0" class="px-5 text-capitalize font-weight-medium" @click="$_confirmar">
            <v-icon left size="20">mdi-trash-can-outline</v-icon>
            Excluir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-bottom-sheet>

    <!-- Bottom sheet para falha de transmissão/conexão -->
    <v-bottom-sheet v-if="tipo === 'erro_conexao'" v-model="localAberto">
      <v-card class="rounded-t-xl">
        <div class="d-flex justify-center pt-3 pb-1">
          <div style="width: 40px; height: 4px; background-color: #e0e0e0; border-radius: 2px;"></div>
        </div>

        <v-card-title class="headline d-flex justify-space-between align-center px-6 pt-2 pb-4">
          <div class="d-flex align-center">
            <v-icon color="error" class="mr-2">mdi-wifi-off</v-icon>
            <span class="font-weight-bold error--text" style="font-size: 1.25rem;">Falha na Transmissão</span>
          </div>
          <v-btn icon color="grey darken-1" small @click="$_cancelar" aria-label="Fechar">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="px-6 pb-4 subtitle-1 text--primary">
          Não foi possível encerrar a O.S. pois ocorreu um erro na transmissão para o servidor. Verifique sua conexão com a internet.
        </v-card-text>

        <v-card-actions class="px-6 pb-6 pt-0 justify-end">
          <v-btn color="error" text class="px-5 text-capitalize font-weight-medium" @click="$_cancelar">
            Entendi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
export default {
  name: 'BottomSheetHandler',

  props: {
    aberto: {
      type: Boolean,
      default: false,
    },
    tipo: {
      type: String,
      required: true,
    },
    dados: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      localAberto: this.aberto,
      localDados: JSON.parse(JSON.stringify(this.dados)),
    };
  },

  watch: {
    aberto(novoValor) {
      this.localAberto = novoValor;
    },
    localAberto(novoValor) {
      if (!novoValor) {
        this.$emit('update:aberto', false);
      }
    },
    dados: {
      handler(novosDados) {
        this.localDados = JSON.parse(JSON.stringify(novosDados));
      },
      deep: true,
    },
  },

  methods: {
    $_confirmar() {
      this.$emit('confirmar');
      this.localAberto = false;
    },

    $_cancelar() {
      this.localAberto = false;
      this.$emit('update:aberto', false);
    },

    formatarValor(valor) {
      if (valor === undefined || valor === null || isNaN(valor)) return 'R$ 0,00';
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(valor);
    },
  },
};
</script>

<style scoped>
</style>
